import React, { useEffect, useState } from "react";
import { useAccount } from "wagmi";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Droplet } from "lucide-react";
import { getAppConfig } from "@/services/config.service";
import { requestFaucet } from "@/services/faucet.service";
import { Hint } from "./SettingsShared";

const FaucetCard = ({ user }) => {
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);
  const { address } = useAccount();

  useEffect(() => {
    getAppConfig().then((c) => setEnabled(!!c.faucet_enabled)).catch(() => {});
  }, []);

  if (!enabled) return null;

  const to = user?.wallet_address || address;

  const drip = async () => {
    if (!to) { toast.error("Connect or link a wallet first"); return; }
    setBusy(true);
    try {
      const r = await requestFaucet(to);
      toast.success(`Sent ${r.amount} test dUSD to your wallet`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Faucet failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="pt-5 mt-2 space-y-3 border-t border-border">
      <div className="flex items-center gap-2">
        <span className="font-display font-semibold">Test faucet</span>
        <span className="text-[10px] uppercase tracking-widest font-bold px-2 py-0.5 rounded-full bg-secondary text-muted-foreground">
          Local
        </span>
      </div>
      <Button variant="outline" onClick={drip} disabled={busy} data-testid="faucet-btn">
        <Droplet className="w-4 h-4 mr-1.5" /> {busy ? "Minting…" : "Get 1000 test dUSD"}
      </Button>
      <Hint>Mints test dUSD to {to ? "your wallet" : "your wallet once connected"} so you can try funding.</Hint>
    </div>
  );
};

export default FaucetCard;
